<template>
  <v-container style="padding: 0; margin: 0">
    <v-layout wrap flex>
      <v-flex xs12>
        <Topo :empresa="empresa" />
        <v-card
          v-show="loading"
          :max-height="heightCard"
          :style="
            loading
              ? 'overflow: auto; background-color: #E1E1E1'
              : 'overflow: auto;'
          "
          class="mb-3"
        >
          <v-layout
            v-if="loading"
            :style="{ height: heightCard }"
            column
            fill-height
            justify-center
            align-center
          >
            <img
              :style="{ height: '200px' }"
              src="assets/videos/brcorte_caw.gif"
            />
            <!--
                    <v-progress-circular
                    :size="50"
                    color="primary"
                    indeterminate
                  >
                  </v-progress-circular>-->
          </v-layout>
        </v-card>
        <material-card
          v-if="
            !loading &&
            ((user.emp_user && user.emp_user.acesso === 0) ||
              user.permissao === 0)
          "
        >
          <h2>{{ strings[idioma].editar_empresa }}</h2>
          <v-form autocomplete="off">
            <v-container py-0>
              <v-layout wrap>
                <v-flex xs12 md12>
                  <v-card class="pa-0 px-5 pb-5">
                    <v-card-title class="headline mx-auto ma-2 px-0">
                      Logotipo da Empresa
                    </v-card-title>
                    <ImageUploader
                      ref="form"
                      v-model="imagem"
                      dialog-title="Logotipo da Empresa"
                      :editable="editLogo"
                      no-data="img/no-avatar.jpg"
                      @delete="deleteCall"
                      @upload="uploadImage()"
                    />
                    <v-row justify="center">
                      <v-dialog
                        v-model="dialogRemoveLogo"
                        persistent
                        max-width="290"
                      >
                        <v-card>
                          <v-card-text
                            >{{ strings[idioma].confirmacao_remover_logo }}
                          </v-card-text>
                          <v-card-actions>
                            <v-btn
                              color="error"
                              text
                              :disabled="buttonRemoveLogo"
                              @click="
                                () => {
                                  imagem = tmpLogo;
                                  dialogRemoveLogo = false;
                                }
                              "
                            >
                              {{ strings[idioma].cancelar }}
                            </v-btn>
                            <v-spacer></v-spacer>
                            <v-btn
                              color="success"
                              text
                              :disabled="buttonRemoveLogo"
                              :loading="buttonRemoveLogo"
                              @click="
                                () => {
                                  removeLogo();
                                }
                              "
                            >
                              {{ strings[idioma].remover }}
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </v-row>
                  </v-card>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    v-model="empresa_.nome"
                    :label="strings[idioma].nome"
                    class="purple-input"
                  />
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    v-model="empresa_.razao_social"
                    :label="strings[idioma].razao_social"
                    class="purple-input"
                  />
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    v-model="empresa_.nome_fantasia"
                    :label="strings[idioma].nome_fantasia"
                    class="purple-input"
                  />
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    v-model="empresa_.cnpj"
                    :rules="cnpjRules"
                    :label="strings[idioma].cnpj"
                    return-value
                    mask="##.###.###/####-##"
                    max-lenght="14"
                    class="purple-input"
                    @change="
                      empresa_.cnpj !== empresa.cnpj ? verificaCNPJ() : null
                    "
                  />
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    v-model="empresa_.inscricao_estadual"
                    :label="strings[idioma].inscricao_estadual"
                    max-lenght="12"
                    class="purple-input"
                  />
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    v-model="empresa_.email"
                    :label="strings[idioma].email"
                    max-lenght="12"
                    class="purple-input"
                  />
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="empresa_.site"
                    :label="strings[idioma].site"
                    max-lenght="12"
                    class="purple-input"
                  />
                </v-flex>
                <template v-if="parseInt(empresa.parceiro) === 1">
                  <v-flex xs12 md6>
                    <v-text-field
                      v-model="empresa_.suporte_link"
                      :label="strings[idioma].suporte + ' Link'"
                      max-lenght="12"
                      class="purple-input"
                    />
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      v-model="empresa_.seja_premium_link"
                      :label="strings[idioma].seja_premium + ' Link'"
                      max-lenght="12"
                      class="purple-input"
                    />
                  </v-flex>
                </template>
                <v-flex xs12 md2>
                  <v-text-field
                    v-model="empresa_.telefone.cod_pais"
                    :label="strings[idioma].cod_pais"
                    :browser-autocomplete="rand()"
                    type="number"
                    class="purple-input"
                    @keypress.native="(val) => $validateOnlyNumbers(val)"
                  />
                </v-flex>
                <v-flex xs12 md2>
                  <v-text-field
                    v-model="empresa_.telefone.DDD"
                    :label="strings[idioma].DDD"
                    type="number"
                    class="purple-input"
                    @keypress.native="(val) => $validateOnlyNumbers(val)"
                  />
                </v-flex>
                <v-flex xs12 md8>
                  <v-text-field
                    v-model="empresa_.telefone.telefone"
                    :label="strings[idioma].telefone"
                    :browser-autocomplete="rand()"
                    type="number"
                    class="purple-input"
                    @keypress.native="(val) => $validateOnlyNumbers(val)"
                  />
                </v-flex>
                <v-flex xs12 md12>
                  <v-autocomplete
                    v-model="empresa_.endereco.pais"
                    :label="strings[idioma].pais"
                    :items="Paises"
                    :item-text="'nome'"
                    :browser-autocomplete="rand()"
                    class="purple-input"
                  />
                </v-flex>
                <v-flex xs12 md3>
                  <v-text-field
                    v-model="empresa_.endereco.cep"
                    :label="strings[idioma].cep"
                    :browser-autocomplete="rand()"
                    class="purple-input"
                  />
                </v-flex>
                <v-flex xs12 md2>
                  <v-autocomplete
                    v-if="empresa_.endereco.pais === 'Brasil'"
                    v-model="empresa_.endereco.estado"
                    :label="strings[idioma].UF"
                    :items="UnidadesFederativas"
                    :item-text="'sigla'"
                    no-data-text=""
                    autocomplete="off"
                    class="purple-input"
                  />
                  <v-text-field
                    v-else
                    v-model="empresa_.endereco.estado"
                    :label="strings[idioma].UF"
                    :browser-autocomplete="rand()"
                    class="purple-input"
                  />
                </v-flex>
                <v-flex xs12 md4>
                  <v-autocomplete
                    v-if="empresa_.endereco.pais === 'Brasil'"
                    v-model="empresa_.endereco.cidade"
                    :label="strings[idioma].cidade"
                    :items="Cidades"
                    :browser-autocomplete="rand()"
                    no-data-text=""
                    class="purple-input"
                  />
                  <v-text-field
                    v-else
                    v-model="empresa_.endereco.cidade"
                    :label="strings[idioma].cidade"
                    :browser-autocomplete="rand()"
                    class="purple-input"
                  />
                </v-flex>
                <v-flex xs12 md3>
                  <v-text-field
                    v-model="empresa_.endereco.bairro"
                    :label="strings[idioma].bairro"
                    :browser-autocomplete="rand()"
                    class="purple-input"
                  />
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    v-model="empresa_.endereco.logradouro"
                    :label="strings[idioma].logradouro"
                    :browser-autocomplete="rand()"
                    class="purple-input"
                  />
                </v-flex>
                <v-flex xs12 md3>
                  <v-text-field
                    v-model="empresa_.endereco.numero"
                    :label="strings[idioma].numero"
                    :browser-autocomplete="rand()"
                    class="purple-input"
                  />
                </v-flex>
                <v-flex xs12 md3>
                  <v-text-field
                    v-model="empresa_.endereco.complemento"
                    :label="strings[idioma].complemento"
                    :browser-autocomplete="rand()"
                    class="purple-input"
                  />
                </v-flex>
                <v-flex xs12 md12>
                  <v-text-field
                    v-model="empresa_.endereco.referencia"
                    :label="strings[idioma].referencia"
                    :browser-autocomplete="rand()"
                    class="purple-input"
                  />
                </v-flex>
                <v-flex xs12 md12>
                  <h3>{{ strings[idioma].dados_financeiro }}</h3>
                </v-flex>
                <v-flex xs12 md12>
                  <v-text-field
                    v-model="empresa_.email_financeiro"
                    :label="strings[idioma].email"
                    max-lenght="12"
                    class="purple-input"
                  />
                </v-flex>
                <v-flex xs12 md2>
                  <v-text-field
                    v-model="empresa_.telefoneFinanceiro.cod_pais"
                    :label="strings[idioma].cod_pais"
                    :browser-autocomplete="rand()"
                    class="purple-input"
                  />
                </v-flex>
                <v-flex xs12 md2>
                  <v-text-field
                    v-model="empresa_.telefoneFinanceiro.DDD"
                    :label="strings[idioma].DDD"
                    :browser-autocomplete="rand()"
                    class="purple-input"
                  />
                </v-flex>
                <v-flex xs12 md8>
                  <v-text-field
                    v-model="empresa_.telefoneFinanceiro.telefone"
                    :label="strings[idioma].telefone"
                    :browser-autocomplete="rand()"
                    class="purple-input"
                  />
                </v-flex>
                <v-flex xs12 md12>
                  <v-autocomplete
                    v-model="empresa_.enderecoFinanceiro.pais"
                    :label="strings[idioma].pais"
                    :items="Paises"
                    :item-text="'nome'"
                    :browser-autocomplete="rand()"
                    class="purple-input"
                  />
                </v-flex>
                <v-flex xs12 md3>
                  <v-text-field
                    v-model="empresa_.enderecoFinanceiro.cep"
                    :label="strings[idioma].cep"
                    :browser-autocomplete="rand()"
                    class="purple-input"
                  />
                </v-flex>
                <v-flex xs12 md2>
                  <v-autocomplete
                    v-if="empresa_.enderecoFinanceiro.pais === 'Brasil'"
                    v-model="empresa_.enderecoFinanceiro.estado"
                    :label="strings[idioma].UF"
                    :items="UnidadesFederativas"
                    :item-text="'sigla'"
                    no-data-text=""
                    autocomplete="off"
                    class="purple-input"
                  />
                  <v-text-field
                    v-else
                    v-model="empresa_.enderecoFinanceiro.estado"
                    :label="strings[idioma].UF"
                    :browser-autocomplete="rand()"
                    class="purple-input"
                  />
                </v-flex>
                <v-flex xs12 md4>
                  <v-autocomplete
                    v-if="empresa_.enderecoFinanceiro.pais === 'Brasil'"
                    v-model="empresa_.enderecoFinanceiro.cidade"
                    :label="strings[idioma].cidade"
                    :items="CidadesFin"
                    :browser-autocomplete="rand()"
                    no-data-text=""
                    class="purple-input"
                  />
                  <v-text-field
                    v-else
                    v-model="empresa_.enderecoFinanceiro.cidade"
                    :label="strings[idioma].cidade"
                    :browser-autocomplete="rand()"
                    class="purple-input"
                  />
                </v-flex>
                <v-flex xs12 md3>
                  <v-text-field
                    v-model="empresa_.enderecoFinanceiro.bairro"
                    :label="strings[idioma].bairro"
                    :browser-autocomplete="rand()"
                    class="purple-input"
                  />
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    v-model="empresa_.enderecoFinanceiro.logradouro"
                    :label="strings[idioma].logradouro"
                    :browser-autocomplete="rand()"
                    class="purple-input"
                  />
                </v-flex>
                <v-flex xs12 md3>
                  <v-text-field
                    v-model="empresa_.enderecoFinanceiro.numero"
                    :label="strings[idioma].numero"
                    :browser-autocomplete="rand()"
                    class="purple-input"
                  />
                </v-flex>
                <v-flex xs12 md3>
                  <v-text-field
                    v-model="empresa_.enderecoFinanceiro.complemento"
                    :label="strings[idioma].complemento"
                    :browser-autocomplete="rand()"
                    class="purple-input"
                  />
                </v-flex>
                <v-flex xs12 md12>
                  <v-text-field
                    v-model="empresa_.enderecoFinanceiro.referencia"
                    :label="strings[idioma].referencia"
                    :browser-autocomplete="rand()"
                    class="purple-input"
                  />
                </v-flex>

                <v-flex xs12>
                  <v-layout xs12 justify-space-between>
                    <v-btn
                      class="mx-0 font-weight-light"
                      color="error"
                      @click="voltar()"
                    >
                      {{ strings[idioma].cancelar }}
                    </v-btn>
                    <v-btn
                      class="mx-0 font-weight-light"
                      color="success"
                      @click="update"
                    >
                      {{ strings[idioma].salvar }}
                    </v-btn>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { mapState } from "vuex";
import {
  getData,
  getDataEmpresa,
  updateData,
  getVinculados,
  resizeBase64Img,
} from "@/utils/utils";
import { estados, paises } from "../../lang/Strings";
import {
  EMPRESA_GESTOR,
  EMPRESA_GERENTE_REGIONAL,
  EMPRESA_TECNICO_VENDA,
  EMPRESA_PRODUTOR_VINCULADO,
  EMPRESA_TIPOS,
} from "../../utils/types";
import Topo from "./Topo";
import moment from "moment";
import { replaceSpecialChars } from "@/utils/vuex";

export default {
  components: {
    Topo,
  },
  data() {
    return {
      users: [],
      imagem: null,
      edit: true,
      editLogo: false,
      dialogRemoveLogo: false,
      buttonRemoveLogo: false,
      removedLogo: false,
      tmpLogo: "",
      empresa_: null,
      empresa: null,
      loading: false,
      cnpjRules: null,
      EMPRESA_GESTOR: EMPRESA_GESTOR,
      EMPRESA_GERENTE_REGIONAL: EMPRESA_GERENTE_REGIONAL,
      EMPRESA_TECNICO_VENDA: EMPRESA_TECNICO_VENDA,
      EMPRESA_PRODUTOR_VINCULADO: EMPRESA_PRODUTOR_VINCULADO,
      EMPRESA_TIPOS: EMPRESA_TIPOS,
    };
  },
  computed: {
    ...mapState("app", [
      "strings",
      "idioma",
      "user",
      "ingredientes",
      "optionsNumber",
      "alimentos_selecionados",
      "categorias_alimentos",
      "alert",
      "dietas",
      "predicoes",
      "tabelas",
      "vinculados",
    ]),
    binding() {
      const binding = {};
      if (this.$vuetify.breakpoint.mdAndUp) binding.row = true;
      else binding.row = false;
      return binding;
    },
    chartOptions() {
      return {
        legend: {
          position: "none",
        },
        chart: {
          responsive: true,
          legend: {
            position: "none",
          },
        },
      };
    },
    filter() {
      return (item, search, textKey) =>
        item[textKey].toLowerCase().search(search.toLowerCase()) > -1;
    },
    heightCard() {
      return String(this.$vuetify.breakpoint.height - 150) + "px";
    },
    widthCard() {
      return String(this.$vuetify.breakpoint.width - 300) + "px";
    },
    heightDialog() {
      return this.$vuetify.breakpoint.xs
        ? String(this.$vuetify.breakpoint.height - 150) + "px"
        : String(this.$vuetify.breakpoint.height - 240) + "px";
    },
    heightOverflow() {
      return (
        "max-height: " +
        String(this.$vuetify.breakpoint.height - 50) +
        "px; overflow-y: auto; overflow-x: hidden;"
      );
    },
    heightTree() {
      return (
        "max-height: " +
        String(this.$vuetify.breakpoint.height - 200) +
        "px; overflow: auto; min-height: 200px;"
      );
    },
    Cargos() {
      return [
        {
          nome: this.strings[this.idioma]["empresa_gestor"],
          nivel: 0,
          id: "empresa_gestor",
        },
        {
          nome: this.strings[this.idioma]["empresa_gerente_regional"],
          nivel: 1,
          id: "empresa_gerente_regional",
        },
        {
          nome: this.strings[this.idioma]["empresa_tecnico_venda"],
          nivel: 2,
          id: "empresa_tecnico_venda",
        },
        {
          nome: this.strings[this.idioma]["empresa_produtor_vinculado"],
          nivel: 3,
          id: "empresa_produtor_vinculado",
        },
      ];
    },
    Usuarios() {
      return this.users;
    },
    UnidadesFederativas() {
      return estados;
    },
    Cidades() {
      let cidades = estados.filter(
        (e) => e.sigla === this.empresa_.endereco.estado
      );
      return cidades.length > 0 ? cidades[0].cidades : [];
    },
    CidadesFin() {
      let cidades = estados.filter(
        (e) => e.sigla === this.empresa_.enderecoFinanceiro.estado
      );
      return cidades.length > 0 ? cidades[0].cidades : [];
    },
    Paises() {
      return paises;
    },
    Proprietario() {
      let prop = this.users.filter(
        (u) => u.id === this.empresa_.id_proprietario
      );
      return prop.length > 0 ? prop[0] : [];
    },
    dietasFilter() {
      if (this.searchDieta === null || this.searchDieta.trim() === "")
        return this.dietas;
      return this.dietas.filter((u) =>
        new RegExp(
          replaceSpecialChars(this.searchDieta.toLowerCase()),
          "i"
        ).test(u.nome ? u.nome : u.name)
      );
    },
    dietasSexoAnimais() {
      const dietas = this.dietasFilter;
      let animais = dietas.map((d) => d.animal);
      let tipos = {};
      for (let animal of animais) {
        if (animal.tipo !== "crescimento_terminacao") continue;
        if (!tipos[animal.sexo]) {
          tipos[animal.sexo] = {
            count: 0,
            name: this.strings[this.idioma][animal.sexo],
          };
        }
        tipos[animal.sexo].count++;
      }
      let dados = [["Animal", "Quantidade"]];
      for (let a of Object.values(tipos)) {
        dados.push([a.name, a.count]);
      }
      return dados;
    },
    dietasGrupoAnimais() {
      const dietas = this.dietasFilter;
      let animais = dietas.map((d) => d.animal);
      let tipos = {};
      for (let animal of animais) {
        if (animal.tipo !== "crescimento_terminacao") continue;
        if (!tipos[animal.raca]) {
          tipos[animal.raca] = {
            count: 0,
            name: this.strings[this.idioma][animal.raca],
          };
        }
        tipos[animal.raca].count++;
      }
      let dados = [["Animal", "Quantidade"]];
      for (let a of Object.values(tipos)) {
        dados.push([a.name, a.count]);
      }
      return dados;
    },
    dietasRegimeAnimais() {
      const dietas = this.dietasFilter;
      let animais = dietas.map((d) => d.animal);
      let tipos = {};
      for (let animal of animais) {
        if (animal.tipo !== "crescimento_terminacao") continue;
        if (!tipos[animal.regime]) {
          tipos[animal.regime] = {
            count: 0,
            name: this.strings[this.idioma][animal.regime],
          };
        }
        tipos[animal.regime].count++;
      }
      let dados = [["Animal", "Quantidade"]];
      for (let a of Object.values(tipos)) {
        dados.push([a.name, a.count]);
      }
      return dados;
    },
    dietasAlimentos() {
      const alimentosSt = JSON.parse(localStorage.getItem("alimentosStored"));
      const dietas = this.dietasFilter;
      let MN = dietas.map((d) => d.resultado);
      let alimentos = {};
      for (let dieta of MN) {
        for (let a in dieta) {
          if (a === "ID_LEITE_VACA") a = "0-0|0|0";
          if (!alimentosSt[a]) continue;
          if (!alimentos[a]) {
            if (alimentosSt[a]) {
              alimentos[a] = {
                count: 0,
                name:
                  this.idioma === 0
                    ? alimentosSt[a].name
                    : alimentosSt[a].name_en,
              };
            }
          }
          alimentos[a].count++;
        }
      }
      alimentos = Object.values(alimentos)
        .sort((a, b) => (a.count > b.count ? -1 : a.count === b.count ? 0 : 1))
        .slice(0, 10);
      let dados = [["Alimento", "Quantidade"]];
      for (let a of Object.values(alimentos)) {
        dados.push([a.name, a.count]);
      }
      return dados;
    },
    dietasAnimais() {
      const dietas = this.dietasFilter;
      let animais = dietas.map((d) => d.animal);
      let tipos = {};
      for (let animal of animais) {
        if (!tipos[animal.tipo]) {
          tipos[animal.tipo] = {
            count: 0,
            name: this.strings[this.idioma][animal.tipo],
          };
        }
        tipos[animal.tipo].count++;
      }
      let dados = [["Animal", "Quantidade"]];
      for (let a of Object.values(tipos)) {
        dados.push([a.name, a.count]);
      }
      return dados;
    },
    predicoesFilter() {
      if (this.searchPredicao === null || this.searchPredicao.trim() === "")
        return this.predicoes;
      return this.predicoes.filter((u) =>
        new RegExp(
          replaceSpecialChars(this.searchPredicao.toLowerCase()),
          "i"
        ).test(u.nome ? u.nome : u.name)
      );
    },
    tabelasFilter() {
      if (this.searchTabela === null || this.searchTabela.trim() === "")
        return this.tabelas;
      return this.tabelas.filter((u) =>
        new RegExp(
          replaceSpecialChars(this.searchTabela.toLowerCase()),
          "i"
        ).test(u.nome ? u.nome : u.name)
      );
    },
    empresasFilter() {
      if (this.searchEmpresas === null || this.searchEmpresas.trim() === "")
        return this.empresas;
      return this.empresas.filter((u) =>
        new RegExp(
          replaceSpecialChars(this.searchEmpresas.toLowerCase()),
          "i"
        ).test(u.nome)
      );
    },
  },
  async created() {
    // this.$store.commit('setDietasServer', this.user.data)
    if (
      this.user.emp_user &&
      this.user.emp_user.acesso !== 0 &&
      this.user.permissao !== 0
    )
      this.voltar();

    let empresa = JSON.parse(sessionStorage.getItem("empresaAdm"));
    this.loading = true;
    try {
      let res = await this.axios.post("empresa/getEmpresa", { id: empresa.id });
      this.empresa = res.data.data;
    } catch (e) {}

    this.queryWork();
    this.cnpjRules = [
      (value) => {
        if (
          value !== null &&
          String(value).trim() !== "" &&
          !this.$testaCNPJ(value)
        ) {
          return value.length >= 11
            ? this.strings[this.idioma].cnpj_invalido
            : ".";
        } else if (
          value !== null &&
          String(value).trim() !== "" &&
          value.length >= 20
        ) {
          return this.strings[this.idioma].cnpj_minimo;
        }
      },
    ];
    setTimeout(() => {
      this.empresa.cnpj = String(this.empresa.cnpj).padStart(14, "0");
      if (this.empresa.site !== null && !this.empresa.site.startsWith("http")) {
        this.empresa.site = "http://" + this.empresa.site;
      }
      if (
        this.empresa.seja_premium_link !== null &&
        !this.empresa.seja_premium_link.startsWith("http")
      ) {
        this.empresa.seja_premium_link =
          "http://" + this.empresa.seja_premium_link;
      }
      if (
        this.empresa.suporte_link !== null &&
        !this.empresa.suporte_link.startsWith("http")
      ) {
        this.empresa.suporte_link = "http://" + this.empresa.suporte_link;
      }
      if (!this.empresa.telefone) {
        this.empresa.telefone = {
          DDD: "",
          cod_pais: "",
          telefone: "",
        };
      } else {
        this.empresa.telefone.telefone = String(
          this.empresa.telefone.telefone
        ).replace("-", "");
      }
      if (!this.empresa.telefone_financeiro) {
        if (!this.empresa.telefoneFinanceiro) {
          this.empresa.telefoneFinanceiro = {
            DDD: "",
            cod_pais: "",
            telefone: "",
          };
        } else {
          this.empresa.telefoneFinanceiro.telefone = String(
            this.empresa.telefoneFinanceiro.telefone
          ).replace("-", "");
        }
      } else {
        this.empresa.telefoneFinanceiro = this.empresa.telefone_financeiro;
        this.empresa.telefoneFinanceiro.telefone = String(
          this.empresa.telefoneFinanceiro.telefone
        ).replace("-", "");
      }
      if (!this.empresa.endereco) {
        this.empresa.endereco = {
          logradouro: "",
          bairro: "",
          cep: "",
          estado: "",
          cidade: "",
          pais: "Brasil",
          numero: "",
          complemento: "",
          referencia: "",
        };
      }
      if (!this.empresa.endereco_financeiro) {
        if (!this.empresa.enderecoFinanceiro) {
          this.empresa.enderecoFinanceiro = {
            logradouro: "",
            bairro: "",
            cep: "",
            estado: "",
            cidade: "",
            pais: "Brasil",
            numero: "",
            complemento: "",
            referencia: "",
          };
        }
      } else {
        this.empresa.enderecoFinanceiro = this.empresa.endereco_financeiro;
      }
      this.axios
        .post("empresa/getLogo", { id: this.empresa.id })
        .then((res) => {
          this.empresa.logo = res.data.data;
          this.reset();
        });
      this.loading = false;
    }, 300);
    this.axios
      .post("empresa/getEmpresas", {})
      .then((r) => {
        this.empresas = r.data.data.empresas;
        this.getData();
        getVinculados(this.$store.state, this.empresa.id, this.axios);
      })
      .catch(() => console.log("/"));
    if (!this.categorias_alimentos) {
      this.loadAlimentosDieta();
    }
  },
  methods: {
    uploadImage() {
      this.empresa.logoModificada = true;
      this.empresa_.logo = this.imagem;
      // var file = document
      //   .querySelector('input[type=file]')
      //   .files[0]
      // var reader = new FileReader()
      // reader.onload = (e) => {
      //   resizeBase64Img(e.target.result, 300, 250).then(res => {
      //     this.empresa_.logo = res
      //   }).catch(_ => {
      //     this.empresa_.logo = e.target.result
      //   })
      // }
      // reader.onerror = (error) => {
      //   alert(error)
      // }
      // reader.readAsDataURL(file)
    },
    changeProprietario() {
      let prop = this.users.filter(
        (u) => u.email === this.empresa_.email_proprietario
      )[0];
      this.empresa_.id_proprietario = prop.id;
    },
    voltar() {
      window.location.href = "/empresa";
    },

    deleteCall() {
      this.dialogRemoveLogo = true;
      this.buttonRemoveLogo = false;
    },

    removeLogo() {
      this.buttonRemoveLogo = true;
      this.removedLogo = true;
      this.dialogRemoveLogo = false;
      this.empresa.logoModificada = true;
      this.imagem = null;
      this.empresa_.logo = "";
    },

    parseString(valor, idioma) {
      if (idioma === 0 && valor && valor !== "-") {
        if (valor[valor.length - 3] === ".") return parseFloat(valor);
        return parseFloat(valor.replace(/[.]/g, "").replace(/[,]/g, "."));
      } else if (valor && valor !== "-") {
        return parseFloat(valor.replace(/[,]/g, ""));
      }
      return 0;
    },
    cnpjValidator(val, input, tipo) {
      return this.$testaCNPJ(String(input[tipo]));
    },
    reset() {
      this.empresa_ = Object.assign({}, this.empresa);
      this.axios
        .post("empresa/getLogo", { id: this.empresa.id })
        .then((res) => {
          this.empresa.logo = res.data.data;
          this.empresa_.logo = res.data.data;
          this.tmpLogo = res.data.data || null;
        });
    },
    update() {
      let err = [];
      if (!this.$validateEmail(this.empresa_.email)) {
        this.loading = false;
        let msg = this.strings[this.idioma].digite_email_valido;
        let time = 6000;
        this.$store.commit("openErrorAlert", { msg, time });
        return;
      }
      if (
        this.empresa_.site !== null &&
        this.empresa_.site.trim() !== "" &&
        !this.empresa_.site.startsWith("http")
      ) {
        this.empresa_.site = "http://" + this.empresa_.site;
      }
      if (
        this.empresa_.seja_premium_link !== null &&
        !this.empresa_.seja_premium_link.startsWith("http")
      ) {
        this.empresa_.seja_premium_link =
          "http://" + this.empresa_.seja_premium_link;
      }
      if (
        this.empresa_.suporte_link !== null &&
        !this.empresa_.suporte_link.startsWith("http")
      ) {
        this.empresa_.suporte_link = "http://" + this.empresa_.suporte_link;
      }
      if (
        String(this.empresa_.email).length < 3 ||
        this.empresa_.email === null
      )
        err.push(this.strings[this.idioma].digite_email_valido);
      if (String(this.empresa_.nome).length < 3 || this.empresa_.nome === null)
        err.push(this.strings[this.idioma].preencha_nome_empresa);
      if (String(this.empresa_.cnpj).length < 3 || this.empresa_.cnpj === null)
        err.push(this.strings[this.idioma].cnpj_incorreto);
      if (
        String(this.empresa_.razao_social).length < 3 ||
        this.empresa_.razao_social === null
      )
        err.push(this.strings[this.idioma].preencha_razao_social);
      if (err.length > 0) {
        alert(err.join("\n"));
        return;
      }
      let dados = {
        id: this.empresa.id,
        id_proprietario: this.Proprietario.id,
        email: this.empresa_.email,
        email_financeiro: this.empresa_.email_financeiro,
        nome: this.empresa_.nome,
        nome_fantasia: this.empresa_.nome_fantasia,
        razao_social: this.empresa_.razao_social,
        inscricao_estadual: this.empresa_.inscricao_estadual,
        telefone: this.empresa_.telefone,
        telefoneFinanceiro: this.empresa_.telefoneFinanceiro,
        endereco: this.empresa_.endereco,
        enderecoFinanceiro: this.empresa_.enderecoFinanceiro,
        cnpj: this.empresa_.cnpj,
        EXCLUIDO: this.empresa_.EXCLUIDO,
        permissao: this.empresa_.permissao,
        site: this.empresa_.site,
        seja_premium_link: this.empresa_.seja_premium_link,
        suporte_link: this.empresa_.suporte_link,
      };
      if (this.empresa.logoModificada === true) {
        dados.logo = this.empresa_.logo;
      }
      this.axios.post("empresa/create", { ...dados }).then((response) => {
        this.empresa.nome = this.empresa_.nome;
        this.empresa.email = this.empresa_.email;
        this.empresa.email_financeiro = this.empresa_.email_financeiro;
        this.empresa.id_proprietario = this.empresa_.id_proprietario;
        this.empresa.razao_social = this.empresa_.razao_social;
        this.empresa.nome_fantasia = this.empresa_.nome_fantasia;
        this.empresa.endereco = this.empresa_.endereco;
        this.empresa.telefone = this.empresa_.telefone;

        this.empresa.enderecoFinanceiro = this.empresa_.enderecoFinanceiro;
        this.empresa.telefoneFinanceiro = this.empresa_.telefoneFinanceiro;
        this.empresa.cnpj = this.empresa_.cnpj;
        this.empresa.EXCLUIDO = this.empresa_.EXCLUIDO;
        this.empresa.permissao = this.empresa.permissao;
        let msg = this.strings[this.idioma].cadastrado;
        let title = "";
        this.$store.commit("openOKModal", { title, msg });
        // this.voltar()
      });
    },
    mudarSenha() {
      this.loading = true;
      this.axios
        .post("/auth/esqueciSenha", { email: this.empresa.email })
        .then((response) => {
          this.loading = false;
          let msg = this.strings[this.idioma].enviado;
          let title = this.strings[this.idioma].mudanca_senha;
          this.$store.commit("openOKModal", { title, msg });
        })
        .catch((reason) => {
          this.loading = false;
          let msg = this.strings[this.idioma].usuario_nao_encontrado;
          let time = 6000;
          this.$store.commit("openErrorAlert", { msg, time });
        });
    },
    verificaCNPJ(fn = null, fncatch = null) {
      if (this.empresa_.cnpj.trim() === this.empresa.cnpj.trim()) {
        fncatch(this.empresa.cnpj);
        return;
      }
      this.axios
        .post("/empresa/verificaCNPJ", { cnpj: this.empresa_.cnpj })
        .catch(() => {
          this.empresa_.cnpj = this.empresa.cnpj;
          let msg = this.strings[this.idioma].cnpj_ja_existente;
          let time = 6000;
          this.$store.commit("openErrorAlert", { msg, time });
          if (fn !== null) {
            fn(this.empresa_.cnpj);
          }
        });
    },
    verificaEmail(fn = null, fncatch = null) {
      if (this.empresa_.email.trim() === this.empresa.email.trim()) {
        fncatch(this.empresa.email);
        return;
      }
      this.axios
        .post("/auth/verificaEmail", {
          email: this.empresa_.email.toLowerCase(),
        })
        .then(() => {
          this.empresa_.email = this.empresa.email.toLowerCase();
          let msg = this.strings[this.idioma].email_ja_existe;
          let time = 6000;
          this.$store.commit("openErrorAlert", { msg, time });
          if (fn !== null) {
            fn(this.empresa_.email);
          }
        })
        .catch(() => {
          if (fncatch !== null) {
            fncatch(this.empresa_.email);
          }
        });
    },
    atualizaVinculo(user) {
      let empresa = this.empresa;
      let usuario = user;
      let cargo = user.cargo;
      let acesso = this.Cargos.filter((c) => cargo === c.nome)[0].nivel;
      this.axios
        .post("empresa/vincula", {
          id_empresa: empresa.id,
          id_pessoa: usuario.id,
          acesso: acesso,
        })
        .then((response) => {
          let msg = this.strings[this.idioma].vinculo_atualizado;
          let title = "";
          this.$store.commit("openOKModal", { title, msg });
          this.getData();
          getVinculados(this.$store.state, this.empresa.id, this.axios);
          this.currUser = null;
          this.dietasCarregadas = null;
        });
    },
    selecionaEmpresa(emp) {
      this.empresa = emp;
      this.getData();
      getVinculados(this.$store.state, this.empresa.id, this.axios);
    },
    queryWork() {
      if (this.$route.query.link) {
        sessionStorage.setItem("link", this.$route.query.link);
        window.location.href = "/";
      } else if (sessionStorage.getItem("link")) {
        let linkURL = sessionStorage.getItem("link");
        sessionStorage.removeItem("link");
        this.linkURL = linkURL;
      }
    },
    loadAlimentosDieta() {
      this.loadingAlimentos = true;
      this.loadingStep1 = true;

      this.axios
        .post("alimentos/lastUpdateAt", {})
        .then((response) => {
          let lastUpdate = parseInt(response.data.data[1]);

          if (lastUpdate === parseInt(localStorage.getItem("lastUpdate"))) {
            if (this.categorias_alimentos) {
              this.loadingStep1 = this.loadingAlimentos = false;
              return;
            }
            let tipos = JSON.parse(localStorage.getItem("tipos"));
            let alimentos = JSON.parse(localStorage.getItem("alimentos"));
            this.$store.commit("setAlimentos", {
              tipos: tipos,
              alimentos: alimentos,
            });
            this.loadingAlimentos = false;
            this.loadingStep1 = false;
          } else {
            this.axios.post("tipos", {}).then((response) => {
              let tipos = response.data.data;
              localStorage.setItem("tipos", JSON.stringify(tipos));
              this.axios
                .post("relatorio/alimentosBrCorte", {})
                .then((response) => {
                  localStorage.setItem(
                    "alimentos",
                    JSON.stringify(response.data.data)
                  );
                  this.$store.commit("setAlimentos", {
                    tipos: tipos,
                    alimentos: response.data.data,
                  });
                  this.loadingAlimentos = false;
                  this.loadingStep1 = false;
                  localStorage.setItem("lastUpdate", lastUpdate);
                })
                .catch((error) => {
                  console.log(error);
                });
            });
          }
        })
        .catch((reason) => {
          console.log(reason);
        });
    },
    moment(...args) {
      return moment(...args);
    },
    getData() {
      if (this.empresa === null) return [];
      return getDataEmpresa(
        this.$store.state,
        this.empresa.id,
        this.axios
      ).then((res) => {
        this.axios
          .post("empresa/getLogo", { id: this.empresa.id })
          .then((res) => {
            this.empresa.logo = res.data.data;
            this.empresa_.logo = res.data.data;

            if (this.empresa_.logo) {
              this.imagem = this.empresa_.logo;
            }
          });
      });
    },
    updateData() {
      return updateData(this.$store.state, this.axios);
    },
  },
};
</script>
